import client from "./client";

export const listInvitations = async () => (await client.get("/invitations")).data;
export const createInvitation = async (body) => (await client.post("/invitations", body)).data;
export const deleteInvitation = (id) => client.delete(`/invitations/${id}`);

export const verifyInvitation = async (token) => (await client.get(`/invitations/verify/${token}`)).data;
export const submitJoin = async (token, body) => (await client.post(`/invitations/${token}/submit`, body)).data;

export const listJoinRequests = async () => (await client.get("/join-requests")).data;
export const approveRequest = async (id, body = {}) => (await client.post(`/join-requests/${id}/approve`, body)).data;
export const rejectRequest = async (id, reason) =>
  (await client.post(`/join-requests/${id}/reject`, { reason })).data;
export const myApprovalStatus = async () => (await client.get("/join-requests/my-status")).data;

export const userDetail = async (id) => (await client.get(`/users/${id}`)).data;
